import { Component } from '@angular/core';
import { ModalChangelogComponent } from '@components/modal-changelog/modal-changelog.component';
import { AnalyticsClickDirective } from '@directives/analytics-click.directive';
import { HideInElectronDirective } from '@directives/hide-in-electron.directive';
import { SFXDirective } from '@directives/sfx.directive';
import { isInIframe } from '@helpers/engine/embed';
import { discordCopyInvite } from '@helpers/engine/discord.ui';
import { NgIconComponent, provideIcons } from '@ng-icons/core';
import {
  tablerBrandDiscord,
  tablerDownload,
  tablerMail,
  tablerRss,
} from '@ng-icons/tabler-icons';
import { TippyDirective } from '@ngneat/helipopper';

@Component({
  selector: 'app-button-connect',
  imports: [
    NgIconComponent,
    TippyDirective,
    ModalChangelogComponent,
    AnalyticsClickDirective,
    HideInElectronDirective,
    SFXDirective,
  ],
  providers: [
    provideIcons({
      tablerBrandDiscord,
      tablerMail,
      tablerRss,
      tablerDownload,
    }),
  ],
  templateUrl: './button-connect.component.html',
  styleUrl: './button-connect.component.scss',
})
export class ButtonConnectComponent {
  public readonly externalLinks = [
    {
      name: 'Discord',
      link: 'https://discord.felfhenor.com',
      color: '#5865f2',
      currentColor: '#ccc',
      icon: 'tablerBrandDiscord',
      copyWhenEmbedded: true,
    },
    {
      name: 'Blog',
      link: 'https://blog.felfhenor.com',
      color: '#e37418',
      currentColor: '#ccc',
      icon: 'tablerRss',
    },
    {
      name: 'Email',
      link: 'mailto:support@felfhenor.com',
      color: '#ce00ce',
      currentColor: '#ccc',
      icon: 'tablerMail',
    },
  ];

  public onLinkClick(
    event: MouseEvent,
    link: string,
    copyWhenEmbedded = false,
  ) {
    if (!copyWhenEmbedded || !isInIframe()) return;

    event.preventDefault();
    void discordCopyInvite(link);
  }
}
